import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormControl,
  FormsModule,
  FormArray,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IttSectionDialogsComponent } from '../itt-section-dialogs.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { environment } from '@/app/environments/environment';
import { ApiErrorResponse } from '@/app/interfaces/apiErrorResponse.interface';
import { MessagesEnum } from '@/app/enums/message.enum';
// TODO: for now commenting out the interface as data is changing.
// import { tendererServiceAdding } from '@/app/interfaces/tendererDialogs.interface';
import { FileManagerComponent } from "@/app/components/shared/file-manager/file-manager.component";
import { ActivatedRoute, Router } from '@angular/router';
import { RfpLabelService } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/rfp-labels.service';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    RichTextEditorComponent,
    FileManagerComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-construction-work',
  templateUrl: './construction-work.component.html',
  styleUrls: ['./construction-work.component.css'],
})
export class ConstructionWorkComponent implements OnInit {
  isRFPorRFQ: string;
  labels: any;
  constructor(
    private IttSectionDialogsComponent: IttSectionDialogsComponent,
    private toast: NgToastService,
    private TenderingService: TenderingService,
    private route: ActivatedRoute,
    private router: Router,
    private rfpLabelService: RfpLabelService
  ) { }
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Output() constructionWorksDataEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Input() tendererResponseData: any;

  base_path = environment.storageUrl;
  resetRichTextEditor = false;
  isEdit = false;
  eoiTitle: FormControl<any>;
  submittedGuidlines: any;

  form: FormGroup = new FormGroup({
    site_preparation_control: new FormControl('', Validators.required),
    civil_works_control: new FormControl('', Validators.required),
    mep_works_control: new FormControl('', Validators.required),
    fit_out_control: new FormControl('', Validators.required),
    health_safety_control: new FormControl('', Validators.required),
    post_construction_control: new FormControl('', Validators.required),
    sitePreparationFileControl: new FormArray([]),
    structureCivilFileControl: new FormArray([]),
    mEPFileControl: new FormArray([]),
    fitOutFileControl: new FormArray([]),
    postConstructionFileControl: new FormArray([]),
    healthSafetyFileControl: new FormArray([]),
  });

  closeModal = true;

  oldSitePreparationFiles = [];
  deletedOldSitePreparationFiles = [];
  oldStructureCivilFiles = [];
  deletedOldStructureCivilFiles = [];
  oldHealthSafetyFiles = [];
  deletedOldHealthSafetyFiles = [];
  oldMEPFiles = [];
  deletedOldMEPFiles = [];
  oldFitOutFiles = [];
  deletedOldFitOutFiles = [];
  oldPostConstructionFiles = [];
  deletedOldPostConstructionFiles = [];

  ngOnInit(): void {
    // Subscribe to route changes
    this.route.url.subscribe(() => {
      const currentRoute = this.router.url; // Get full URL path
      this.rfpLabelService.updateLabelsFromRoute(currentRoute);
      this.isRFPorRFQ = this.rfpLabelService.updateRFPorRFQFlag(currentRoute);
    });
    this.rfpLabelService.labels$.subscribe((labels) => {
      this.labels = labels;
    });
    this.TenderingService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });

    if (this.tendererResponseData) {
      this.mapRFPExistingData();
    }
  }

  setSitePreparation(content: string) {
    this.form.controls['site_preparation_control'].setValue(content);
  }
  setStructuralCivilWorks(content: string) {
    this.form.controls['civil_works_control'].setValue(content);
  }
  setMEPWorks(content: string) {
    this.form.controls['mep_works_control'].setValue(content);
  }
  setFitOut(content: string) {
    this.form.controls['fit_out_control'].setValue(content);
  }
  setHealthSafetyCompliance(content: string) {
    this.form.controls['health_safety_control'].setValue(content);
  }
  setPostConstruction(content: string) {
    this.form.controls['post_construction_control'].setValue(content);
  }

  moveToPreviousStep() {
    this.IttSectionDialogsComponent.previousStep();
  }

  prepareDataToSubmit() {
    if (this.form.valid) {
      const dataToSubmit = new FormData();
      dataToSubmit.append(
        'site_preparation',
        this.form.value.site_preparation_control
      );
      dataToSubmit.append(
        'structural_civil_works',
        this.form.value.civil_works_control
      );
      dataToSubmit.append('mep_works', this.form.value.mep_works_control);
      dataToSubmit.append('finishing_fitout', this.form.value.fit_out_control);
      dataToSubmit.append(
        'health_safety_compliance',
        this.form.value.health_safety_control
      );
      dataToSubmit.append(
        'post_construction_activities',
        this.form.value.post_construction_control
      );

      // Files handling Start
      this.addUploadedFiles(dataToSubmit);
      this.addDeletedOldFilesIds(dataToSubmit);
      // Files handling End

      return dataToSubmit;
    }
  }

  // NOTE: when submitting form, add new files in data
  addUploadedFiles(submissionFormData) {
    this.form.value.sitePreparationFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('site_preparation_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.mEPFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('mep_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.fitOutFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('fit_out_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.postConstructionFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('post_construction_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.structureCivilFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('structure_civil_attach[]', uploadedFile);
        }
      }
    );
    this.form.value.healthSafetyFileControl.forEach(
      (uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append('health_safety_attach[]', uploadedFile);
        }
      }
    );
  }

  // NOTE: on submit, append deleted files ids in data
  addDeletedOldFilesIds(submissionFormData) {
    if (this.deletedOldSitePreparationFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldSitePreparationFilesIds',
        JSON.stringify(this.deletedOldSitePreparationFiles)
      );
    }
    if (this.deletedOldMEPFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldMEPFilesIds',
        JSON.stringify(this.deletedOldMEPFiles)
      );
    }
    if (this.deletedOldFitOutFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldFitOutFilesIds',
        JSON.stringify(this.deletedOldFitOutFiles)
      );
    }
    if (this.deletedOldPostConstructionFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldPostConstructionFilesIds',
        JSON.stringify(this.deletedOldPostConstructionFiles)
      );
    }
    if (this.deletedOldStructureCivilFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldStructureCivilFilesIds',
        JSON.stringify(this.deletedOldStructureCivilFiles)
      );
    }
    if (this.deletedOldHealthSafetyFiles?.length > 0) {
      submissionFormData.append(
        'deletedOldHealthSafetyFilesIds',
        JSON.stringify(this.deletedOldHealthSafetyFiles)
      );
    }
  }

  moveToNextStep() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.toast.warning(MessagesEnum.REQUIRED_ALL_FIELDS, 'WARNING', 4000);
      return;
    } else {
      const dataToSubmit = this.prepareDataToSubmit();
      this.TenderingService.addITTConstructionWork(dataToSubmit).subscribe({
        next: (response: any) => {
          if (response?.meta?.success) {
            this.toast.success(response?.meta?.message, 'SUCCESS');
            this.constructionWorksDataEmitter.emit(response?.data);
            this.IttSectionDialogsComponent.nextStep();
          }
        },
        error: (error: ApiErrorResponse) => {
          console.error(error.error.message, error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
  }
  handleBack() {
    this.TenderingService.setEditState(true);
    this.IttSectionDialogsComponent.previousStep();
  }

  mapRFPExistingData() {
    if (!this.tendererResponseData) {
      console.warn('Tenderer Response Data is undefined');
      return;
    }

    this.form.patchValue({
      site_preparation_control:
        this.tendererResponseData?.sitePreparation ?? '',
      civil_works_control: this.tendererResponseData?.civilWorks ?? '',
      mep_works_control: this.tendererResponseData?.mepWorks ?? '',
      fit_out_control: this.tendererResponseData?.fitOut ?? '',
      health_safety_control: this.tendererResponseData?.healthSafety ?? '',
      post_construction_control:
        this.tendererResponseData?.postConstruction ?? '',
    });

    this.oldSitePreparationFiles = this.tendererResponseData?.site_preparation_attach ?? [];
    this.oldStructureCivilFiles = this.tendererResponseData?.structure_civil_attach ?? [];
    this.oldMEPFiles = this.tendererResponseData?.mep_work_attach ?? [];
    this.oldFitOutFiles = this.tendererResponseData?.finishing_fitout_attach ?? [];
    this.oldHealthSafetyFiles = this.tendererResponseData?.health_safety_attach ?? [];
    this.oldPostConstructionFiles = this.tendererResponseData?.post_construction_attach ?? [];
  }

  /**
   * Handling File Operations - START
   */
  // Uploading/Deleting new files for site preparation
  handleNewFiles(filesData: {
    files: File[],
    controlName: string,
    isEmpty: boolean,
  }) {
    switch (filesData.controlName) {
      case 'sitePreparationFileControl': {
        const fileArray = this.form.get('sitePreparationFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'mEPFileControl': {
        const fileArray = this.form.get('mEPFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'fitOutFileControl': {
        const fileArray = this.form.get('fitOutFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'postConstructionFileControl': {
        const fileArray = this.form.get('postConstructionFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'structureCivilFileControl': {
        const fileArray = this.form.get('structureCivilFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      case 'healthSafetyFileControl': {
        const fileArray = this.form.get('healthSafetyFileControl') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      default:
        break;
    }
  }

  handleDeletedOldFiles(OldFileData: any) {
    switch (OldFileData.controlName) {
      case 'sitePreparationFileControl': {
        this.deletedOldSitePreparationFiles.push(OldFileData?.file?.id);
        this.oldSitePreparationFiles = this.oldSitePreparationFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'mEPFileControl': {
        this.deletedOldMEPFiles.push(OldFileData?.file?.id);
        this.oldMEPFiles = this.oldMEPFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'fitOutFileControl': {
        this.deletedOldFitOutFiles.push(OldFileData?.file?.id);
        this.oldFitOutFiles = this.oldFitOutFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'postConstructionFileControl': {
        this.deletedOldPostConstructionFiles.push(OldFileData?.file?.id);
        this.oldPostConstructionFiles = this.oldPostConstructionFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'structureCivilFileControl': {
        this.deletedOldStructureCivilFiles.push(OldFileData?.file?.id);
        this.oldStructureCivilFiles = this.oldStructureCivilFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }
      case 'healthSafetyFileControl': {
        this.deletedOldHealthSafetyFiles.push(OldFileData?.file?.id);
        this.oldHealthSafetyFiles = this.oldHealthSafetyFiles.filter(file => file.id !== OldFileData?.file?.id);
        break;
      }

      default:
        break;
    }
  }
  /**
   * Handling File Operations - END
   */

}
